import { WALL } from './data/wall'

/** The developer surface: nine linked cards in three rows, the ones a newcomer looks for first. */
export const Wall = () => (
  <section
    className="page-section page-section--lg developers-wall bg-soft"
    id="surface"
  >
    <div className="page-section__inner">
      <hgroup className="developers-wall__head">
        <h2 className="heading-xl text-brand-dark">The developer surface</h2>
        <p className="body-l text-primary">
          Tools, agents, and protocols for building and deploying AI analytics.
        </p>
      </hgroup>
      <div className="developers-wall__grid">
        {WALL.map((card) => (
          <article className="t-card" key={card.name}>
            <span
              className="t-ico"
              dangerouslySetInnerHTML={{ __html: card.icon }}
            />
            <h3 className="heading-s text-brand-dark">{card.name}</h3>
            <p
              className="body-s"
              dangerouslySetInnerHTML={{ __html: card.html }}
            />
            <div className="t-links">
              {card.links.map((link) => (
                <a
                  className={`t-link k-${link.kind}`}
                  href={link.href}
                  key={link.href + link.label}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)
